import Document from "./document";

class Result {
  public Document: Document;
  public Score: number;

  constructor(doc: Document, score: number) {
    this.Document = doc;
    this.Score = score;
  }
}

export default Result;



// WEBPACK FOOTER //
// ./src/models/result.ts